import { useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { fetchProfileAction } from '../../../redux/actions/profileAction';
import { AppDispatch } from 'redux/store';

export const AuthLayout = () => {
	const dispatch = useDispatch<AppDispatch>();
	const navigate = useNavigate();
	const location = useLocation();
	const isApiCalled = useRef<boolean>(false);
	// Static paths that don't require authentication
	const authPaths = useMemo(() => [
		'/login',
		'/reset-password',
		'/forgot-password',
		'/set-password',
	], []);

	//ANCHOR - to prevent the page from being opened in a new tab in iframe or sandbox environment
	useEffect(() => {
		if (window?.top !== window?.self && window?.top) {
			window.top.location.href = window.self.location.href;
		}
	}, []);


	useEffect(() => {
		const token = localStorage.getItem('accessToken');

		// If there's no token and path is not public, redirect to login
		if (!token && !authPaths.includes(location.pathname)) {
			navigate('/login', { replace: true });
			return;
		}

		// If token exists and user is trying to access an auth page, redirect to home
		if (token && authPaths.includes(location.pathname)) {
			navigate('/', { replace: true });
			return;
		}

		// If token exists, fetch profile
		if (token && !isApiCalled.current) {
			isApiCalled.current = true;
			dispatch(fetchProfileAction())
				.unwrap()
				.catch(() => {
					// If fetching profile fails, redirect to login (but avoid infinite loop)
					if (!authPaths.includes(location.pathname)) {
						navigate('/login', { replace: true });
					}
				});
		}
	}, [dispatch, location.pathname, navigate, authPaths]);

	return <Outlet />;
};
